import * as Sentry from '@sentry/react';
import * as Spotlight from '@spotlightjs/spotlight';
import React from 'react';
import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';
import 'react-toastify/dist/ReactToastify.css';

import { appService } from 'services';
import 'services/fontAwesomeLibrary';

import 'assets/styles/app.scss';

import App from './App';
import Providers from './Providers';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENV,
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation: React.useLocation,
      useNavigationType: React.useNavigationType,
      createRoutesFromChildren: React.createRoutesFromChildren,
      matchRoutes: React.matchRoutes
    }),
    Sentry.replayIntegration({
      // Additional SDK configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true
    })
  ],
  ignoreErrors: [/.*unauthorized access.*/, /.*code 401.*/],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  tracesSampleRate: process.env.REACT_APP_SENTRY_TRACES_SAMPLE,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    /^https:\/\/dev\.touloisirs\.fr/,
    /^https:\/\/preprod\.touloisirs\.fr/,
    /^https:\/\/touloisirs\.fr/,
    /^https:\/\/.*\.arrivaj\.fr/
  ],

  replaysSessionSampleRate: process.env.REACT_APP_SENTRY_REPLAY_SESSION_SAMPLE,
  replaysOnErrorSampleRate: process.env.REACT_APP_SENTRY_REPLAY_ERROR_SAMPLE
});
if (process.env.REACT_APP_SENTRY_ENV === 'Développement') {
  Spotlight.init({
    sidecarUrl: 'https://dev-spotlight.touloisirs.fr/stream'
  });
}

const tagManagerArgs = {
  gtmId: appService.getGtmId(),
  debug: true
};

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Providers>
    <App />
  </Providers>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
